// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"WizardLayout_loadingOverlay__xhenX"};